import Cookies from "js-cookie";
import axios from "axios";
import { getBaseUrl } from "../../utils";

const getmedia_categories = getBaseUrl() + "admin/media_categories";
const status_update_categories = getBaseUrl() + "admin/updateCategory";
const deleteCategory = getBaseUrl() + "admin/media_category/";
const addCategory = getBaseUrl() + "admin/media_category";
const updateCategory = getBaseUrl() + "admin/media_category";

export const updateCategory_api = async (data, id) => {
  let config = {
    method: "patch",
    url: updateCategory + `/${id}`,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
export const addCategory_api = async (data) => {
  let config = {
    method: "post",
    url: addCategory,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const deleteCategory_api = async (data) => {
  let config = {
    method: "delete",
    url: deleteCategory + `${data.id}`,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
export const status_update_categories_api = async (data) => {
  let config = {
    method: "PATCH",
    url: status_update_categories,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const getCategories_api = async (data) => {
  let config = {
    method: "get",
    // url: getCategories + `?page=${data.page}&limit=${data.limit}&search=${data.search}`,
    url:
      getmedia_categories +
      `?page=${data.page}&limit=${data.limit}&search=${data.search}`,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
